import React from 'react';
import { motion } from 'motion/react';

interface PageHeaderProps {
  title: string;
  description?: string;
  centered?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, description, centered = true }) => {
  return (
    <div className={`pt-32 pb-16 lg:pt-48 lg:pb-24 bg-slate-50 border-b border-slate-100 ${centered ? 'text-center' : ''}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto space-y-6"
        >
          <h1 className="text-4xl lg:text-6xl font-extrabold text-slate-900 tracking-tight leading-tight">
            {title}
          </h1>
          {description && (
            <p className="text-lg lg:text-xl text-slate-600 leading-relaxed">
              {description}
            </p>
          )}
          <div className={`w-20 h-1.5 bg-primary rounded-full ${centered ? 'mx-auto' : ''}`}></div>
        </motion.div>
      </div>
    </div>
  );
};

export default PageHeader;
